import PropTypes from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";

import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";

import { FnrPopover } from "UI/FnrPopover2";

import formatSqlDateIntoJsDate from "Utilities/Date/formatSqlDateIntoJsDate";

SkippedPaymentsButton.propTypes = {
  futureSkippedPayments: PropTypes.array,
  paymentType: PropTypes.string,
  status: PropTypes.string,
};

export default function SkippedPaymentsButton({
  futureSkippedPayments = [],
  paymentType,
  status,
}) {
  const [showPopover, setShowPopover] = useState(false);

  const buttonRef = useRef();

  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  const skippedPayments = futureSkippedPayments.map((sqlDate) => {
    const date = formatSqlDateIntoJsDate(sqlDate);
    const month = date.toLocaleString("default", { month: "long" });
    const day = date.getDate();
    return `${month} ${day}`;
  });

  const determineSkippedPaymentsText = () => {
    switch (skippedPayments.length) {
      case 1:
        return <strong>{skippedPayments[0]}</strong>;
      case 2:
        return (
          <>
            <strong>{skippedPayments[0]}</strong> and{" "}
            <strong>{skippedPayments[1]}</strong>
          </>
        );
      case 3:
        return (
          <>
            <strong>{skippedPayments[0]}</strong>,{" "}
            <strong>{skippedPayments[1]}</strong> and{" "}
            <strong>{skippedPayments[2]}</strong>
          </>
        );
      default:
        return (
          <>
            <strong>{skippedPayments[0]}</strong> and{" "}
            <strong>{skippedPayments.length - 1}</strong> other dates
          </>
        );
    }
  };

  const handleClose = () => setShowPopover(false);

  if (
    !futureSkippedPayments.length ||
    status === "paused" ||
    status === "stopped" ||
    status === "expired"
  )
    return null;

  return (
    <>
      <SkippedPaymentsIcon
        className="fas fa-share-all"
        ref={buttonRef}
        onMouseEnter={() => setShowPopover(true)}
        onMouseLeave={() => setShowPopover(false)}
      />
      <FnrPopover
        buttonRef={buttonRef}
        show={showPopover}
        onShouldClose={handleClose}
      >
        <PopoverContent>
          <PopoverTitle>
            Skipped{" "}
            {skippedPayments.length > 1
              ? paymentTypeHandler.plural()
              : paymentType}
          </PopoverTitle>
          <PopoverBorder />
          This recurring {paymentType} has{" "}
          {skippedPayments.length > 1 ? "" : "a"} skipped payment
          {skippedPayments.length > 1 ? "s" : ""} on{" "}
          {determineSkippedPaymentsText()}.
        </PopoverContent>
      </FnrPopover>
    </>
  );
}

const SkippedPaymentsIcon = styled.div`
  cursor: help;
  font-size: 21px;
  opacity: 0.9;
  transition: all 250ms;

  &:hover {
    opacity: 1;
  }
`;

const PopoverContent = styled.div`
  margin: 10px;
  max-width: 260px;
`;

const PopoverTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  text-transform: uppercase;
`;

const PopoverBorder = styled.div`
  height: 1px;
  background: #eceff0;
  margin: 6px 0;
`;
